const submissionMappingReason = {
    RENEWAL : 0,

    REWRITE : 1,

    RESUBMIT : 2

};

angular.module('gw-um-j2js')
    .constant('submissionMappingReason', submissionMappingReason);